<template>
  <div class="content">
    <div class="banner"><img :src="$t('market.banner')"></div>
    <!-- <div class="newsList" v-show="showType">
        <div class="newsItem" v-for="(item,index) in $t('market.activityList')" :key="index"  @click="jumpDetail(item)">
            <img :src="item.imgUrl" >
            <div class="newDetail" style="padding: 5px 10px;">
                <span>{{item.title}}</span>
                <p v-html="item.content"></p>
            </div>
        </div>
    </div> -->
    <div style="width:80%;margin:20px auto auto auto;height:500px;display:flex;align-items: center;">
        <slider ref="slider" :options="options" class="newsList">
            <slideritem v-for="(item,index) in $t('market.activityList')" :key="index" class="newsItem ZoomIn">
                <img :src="item.imgUrl" style="height:160px,width:200px" @click="jumpDetail(item)">
                <div class="newDetail" style="padding: 5px 10px;" @click="jumpDetail(item)">
                    <span>{{item.title}}</span>
                    <!-- <p v-html="item.content"></p> -->
                    <p>{{item.contentDate}}</p>
                </div>
            </slideritem>
        </slider>
    </div>
  </div>
</template>

<script>
import marketApi from '../../api/market'
import izh from "../../i18n/zh";
import ien from "../../i18n/en";
import { slider, slideritem } from 'vue-concise-slider'
  export default {
    name: 'market',
    components:{slider,slideritem},
    data: () => ({
        showType: false,
        options: {
            // currentPage: 0,
            // tracking: false,
            thresholdDistance: 100,
            thresholdTime: 300,
            // infinite: 4,
            // slidesToScroll: 4,
            // loop: false,
            // itemAnimation: true
        }
    }),
    methods:{
        toolPictureOrIconSplitFn(info,a,b){
            if(this.lang==='zh'){
                return info[a]?info[a].split(','):[];
            }
            else if(this.lang==='en'){
                return info[b]?info[b].split(','):[];
            }
            else{
                return []
            }   
        },
        jumpDetail(item){
            if( item.externalLink ) window.open(item.externalLink,'_blank')
            else this.$router.push( {path: '/marketDetail', query: { id: item.contentId }} );
        },
        async getData(){
            let { data: bannerData } = await marketApi.getBanner();
            let { data: activityData } = await marketApi.getActivityList();
            let activityDataList = activityData[0].contents;
            let zhList=[],enList=[];
            activityDataList.forEach(item => {
                zhList.push({ contentId: item.contentId, title:item.contentNameZhCn, content: item.contentZhCn , externalLink:item.externalLink,imgUrl: item.picturesZhCn, contentDate: item.contentDate ? item.contentDate?.substring(0,item.contentDate?.indexOf('00')-1) : item.contentDate });
                enList.push({ contentId: item.contentId, title:item.contentNameEnUs ? item.contentNameEnUs : item.contentNameZhCn, content: item.contentEnUs ? item.contentEnUs : item.contentZhCn,externalLink:item.externalLink, imgUrl: item.picturesEnUs ? item.picturesEnUs : item.picturesZhCn, contentDate: item.contentDate ? item.contentDate?.substring(0,item.contentDate?.indexOf('00')-1) : item.contentDate });
            });
            izh.market = {
                ...izh.market,
                banner: bannerData[0].contents[0].picturesZhCn,
                activityList: zhList
            };
            ien.market = {
                ...ien.market,
                banner: bannerData[0].contents[0].picturesEnUs ? bannerData[0].contents[0].picturesEnUs : bannerData[0].contents[0].picturesZhCn,
                activityList: enList
            }
            this.showType = true;
        },
    },
    mounted(){
        this.getData();
    }
  }
</script>
<style lang="scss" scoped>
    .ZoomIn{
        cursor: pointer;
        transition: all .3s ease-in 0s;
    }
    .ZoomIn:hover{
        transform: scale(1.01);
        transition: all 0.3s ease-in;
    }
    .content{
        min-height: 80vh;
        width: 100vw;
        background: #f8f8f8;
    }
    .banner{
        width: 100vw;
        img{
            width: 100%;
        }
    }
    .seamless-warp{
        height: 280px;
        overflow: hidden;
    }
    ::v-deep.slider-touch{
        width: 70%;
    }
    .newsList{
        min-height: 400px;
        // width: 100%;
        margin-left: 5%;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start ;
        margin-right: 10px;
        .newsItem{
            height: 360px;
            // width: 24%;
            width: 224px;
            background: #fff;
            border-radius: 2px;
            display: flex;
            flex-direction: column;
            color: #000;
            font-size: 14px;
            margin-right: 2%;
            white-space: pre-wrap;
            img{
                height: 220px;
                // height: 14rem;
                width: 220px;
            }
            .newDetail{
                height: 150px;
                width: 92%;
                text-align: start;
                position: relative;
                p{
                    position: absolute;
                    left: 5%;
                    bottom: 5%;
                }
            }
        }
    }
    @media screen and (max-width: 540px) {
        .newsItem{
        width: 76vw!important;
        margin-left: 13vw;
        img{
            height: 76vw!important;
            width: 76vw!important;
        }
        }
    }

    .moreItem{
        cursor: pointer;
        height: 40px;
        line-height: 40px;
        width: 120px;
        color: #c7c7c7;
        border: 1px solid #c7c7c7;
        border-radius: 20px;
        text-align: center;
        margin-left: 50%;
        transform: translateX(-50%);
        margin-bottom: 10px;
    }
</style>
